import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GlTransactionDetailData {
  type: string;
  number: string;
  trandate: string;
  debit: number;
  credit: number;
  chequeno: string;
  narrative: string;
  balance: number;
  tag: string;
  periodno?: number | string;
  periodname?: string;
}

@Component({
  selector: 'app-gl-transaction-detail-modal',
  templateUrl: './transaction-detail-modal.component.html',
  styleUrls: ['./transaction-detail-modal.component.scss']
})
export class TransactionDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<TransactionDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GlTransactionDetailData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}


